import * as React from 'react';
import Button from '@mui/material/Button';
import {Grid, Stack, Typography} from "@mui/material";

export default function ConfirmationDialog(props) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <Stack justifyContent="center" alignContent="center">
                <Typography variant="subtitle1" sx={{ p:2}}>{props.message}</Typography>
                <Grid container spacing={1}>
                    <Grid item xs={10}></Grid>
                    <Grid item xs={1}><Button onClick={() => props.handleClose()}>Cancel</Button></Grid>
                    <Grid item xs={1}><Button onClick={() => props.handleOk()} autoFocus>ok</Button></Grid>
                </Grid>
            </Stack>
        </div>
    );
}